import BannerNew from '../../components/BannerNew';
import Catalog from './components/Catalog';
import Hero from './components/Hero';
import HowToSection from './components/HowToSection';
import ImageGallery from '../../components/ImageGallery';
import SeoSection from './components/SeoSection';
import FAQ from '../../components/FAQ';
import Templates from './components/Templates';
import Community from '../../components/Community';
import styled from 'styled-components';
import Instagram from './components/Instagram';

import SeoHead from '../../../../app/components/SeoHead';
import FaceBook from './components/Facebook';
import { useEffect } from 'react';

const Wrapper = styled.section`
  .main-container {
    width: 100%;
    height: 100%;
  }
`;

const seoData = {
  title: ' Building and hosting high quality Floral Websites | BoostFloral',
  description:
    'Building and Hosting your e-commerce Floral Website has never been easier or quicker.  The BoostFloral platform addresses the specific needs of Florists.',
  keywords:
    'Flower Shop Websites, Floral Web Design Software, Floral CMS, Building a Floral Website',
  ogTitle: 'Build and host high quality Floral Websites with BoostFloral!',
  ogDescription:
    'Building and Hosting your e-commerce Floral Website has never been easier or quicker with the Number 1 Floral Web Design Software.  The BoostFloral software addresses the specific needs of Florists.',
  ogType: 'company',
  ogSiteName: 'BoostFloral',
};

const Home = () => {

  return (
    <Wrapper>
      <SeoHead data={seoData} />
      <div className="main">
        <Hero />
        <HowToSection />
        <Templates />
        <Community />
        <ImageGallery />
        <Catalog />
        <BannerNew title={'Build a Custom Floral Website Today'} />
        <SeoSection />
        <FAQ comingFrom="home" />
      </div>
    </Wrapper>
  );
};

export default Home;
